import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, mappingResultError, Result, UseCase } from '@digibricks/core';
export var UPDATE_SUB_QUESTION_USE_CASE = 'UPDATE_SUB_QUESTION_USE_CASE';
export var UpdateSubQuestionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(UpdateSubQuestionUseCase, _UseCase);

  var _super = _createSuper(UpdateSubQuestionUseCase);

  function UpdateSubQuestionUseCase() {
    _classCallCheck(this, UpdateSubQuestionUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateSubQuestionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var currentQuestion, data, guardCollection, guardResult, description, id, subQuestion, updatedResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                currentQuestion = input.currentQuestion, data = input.data;
                guardCollection = [{
                  argument: currentQuestion,
                  argumentName: 'Current Question'
                }, {
                  argument: data,
                  argumentName: 'Data input'
                }];
                guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

                if (guardResult.succeeded) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", new BadInputError(guardResult.message));

              case 5:
                description = data.description, id = data.id;
                subQuestion = currentQuestion.subQuestions.find(function (s) {
                  return s.id.toString() === id;
                });

                if (subQuestion) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", new BadInputError('Sub Question does not exist '));

              case 9:
                if (!(description || description === '')) {
                  _context.next = 14;
                  break;
                }

                updatedResult = subQuestion.updateDescription(description);

                if (!updatedResult.isFailure) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", mappingResultError(updatedResult));

              case 13:
                currentQuestion.updateSubQuestion(subQuestion);

              case 14:
                return _context.abrupt("return", Result.ok(currentQuestion));

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return UpdateSubQuestionUseCase;
}(UseCase);